import { render, staticRenderFns } from "./MyClassIndex.vue?vue&type=template&id=a07da940&"
import script from "./MyClassIndex.vue?vue&type=script&lang=js&"
export * from "./MyClassIndex.vue?vue&type=script&lang=js&"
import style0 from "./MyClassIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports